import React from "react";
import { Button, Form, Input } from "antd";
import { Link } from "react-router-dom";

const RequestNumber = ({ form, disabled }) => {
  const { getFieldDecorator, getFieldValue } = form;
  return (
    <div className="offer-card__item">
      <span className="label">Номер заявки:</span>
      <Form.Item>
        {getFieldDecorator("requestNumber")(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </Form.Item>
      <Form.Item hidden={true}>
        {getFieldDecorator("requestId")(<Input disabled={disabled} />)}
      </Form.Item>
      <span className="extra-label">
        <span className="show-map">
          <Link
            target="_blank"
            to={`/executorship/request/${getFieldValue("requestId")}`}
          >
            <Button type="primary" ghost onClick={() => {}}>
              Подробнее
            </Button>
          </Link>
        </span>
      </span>
    </div>
  );
};
export default RequestNumber;
